export const authFormFields = {
    "login": {
        "email": true,
        "password": true,
        "dontHaveAnAccount": true,
        "forgotPassword": true,
        "googleAuth": true,
    },
    "signup": {
        "email": true,
        "password": true,
        "fullName": true,
        "haveAnAccount": true,
        "termsAndService": true,
        "googleAuth": true,
    },
    initiateReset: {
        "email": true,
        "haveAnAccount": true,
    },
    "reset": {
        "password": true,
        "confirmPassword": true,
        "haveAnAccount": true,
    },
};

export const authFieldsToValidate = {
    "login": {
        "email": true,
        "password": true,
    },
    "signup": {
        "email": true,
        "password": true,
        "fullName": true,
        "termsAndService": true,
    },
    initiateReset: {
        "email": true,
    },
    "reset": {
        "password": true,
        "confirmPassword": true,
    },
};

export const authCopy = {
    "login": {
        title: "Sign in to your account",
        subtitle: "",
        linkText: "Sign up",
        btnLabel: "Login",
    },
    "signup": {
        title: "Create your account",
        linkText: "Login",
        btnLabel: "Sign up",
        subtitle: "",
    },
    initiateReset: {
        title: "Initiate Password Reset",
        subtitle: "Enter the email address associated with your account to get a password reset link",
        btnLabel: "Send reset link",
        linkText: "",
    },
    "reset": {
        title: "Create a new password",
        subtitle: "Enter a new password that is not the same as your previous password",
        btnLabel: "Reset your password",
        linkText: "",
    },
};

export const updateProfileFields = {
    profile: {
        title: "Manage contact information",
        fields: {
            fullName: true,
            brandName: true,
            phoneNumber: true,
            address: true,
            country: true,
            zipCode: true, 
            occupation: true,
            bio: true, 
        },
    },
    emailSettings: {
        title: "Manage email address",
        fields: {
            email: true,
        },
    },
};

export const generalModalFields = {
    appearance: {
        title: "Update Apperance & theme",
        fields: {
            theme: true,
        },
    },
    timeSettings: {
        title: "Update time settings",
        fields: {
            timeZone: true,
            timeFormat: true,
            dateFormat: true,
            dayOfWeek: true,  
        },
    },
    currency: {
        title: "Update language & currency",
        fields: {
            language: true,
            currency: true,
        },
    },
};

export const updateClientDetailsFields = {
    name: {
        title: "Edit name",
        fields: {
            name: true, 
        },
    },
    create: {
        title: "Onboard a new client",
        fields: {
            name: true,
            email: true,
            address: true,
            country: true,
            phoneNumber: true,
            city: true,
            state: true,
            zipCode: true,
            status: true,
            industry: true,
            ccEmails: true, 
        },
    },
    billingEmails: {
        title: "Manage corresponding emails",
        fields: {
            ccEmails: true, 
        },
    },
    clientDetails: {
        title: "Update client information",
        fields: {
            email: true,
            industry: true,
            address: true,
            country: true,
            phoneNumber: true,
            city: true,
            state: true,
            zipCode: true,
        },
    },
};

export const updateProjectDetailsFields = {
    create_non_paid: {
        title: "Add project",
        fields: {
            title: true,
            deadline: true,
            startDate: true,
            priority: true,
            projectType: true,
            status: true,
            reminders: true, 
        },
        cta: "Create project",
    },
    create_paid: {
        title: "Add project",
        fields: {
            title: true,
            deadline: true,
            startDate: true,
            billingType: true,
            nonBillableHours: true,
            billingRate: true,
            priority: true,
            projectType: true,
            status: true,
            currency: true, 
            billableHours: true, 
            estimatedRevenue: true, 
            reminders: true, 
        },
        cta: "Create project",
    },
    name: {
        title: "Update project title",
        fields: {
            title: true, 
        },
        cta: "Update title",
    },
    description: {
        title: "Project description",
        fields: {
            description: true, 
        },
        cta: "Update",
    },
    estimatedRevenue:  {
        title: "Estimated revenue for this project",
        fields: {
            // projectType: true,
            currency: true, 
            estimatedRevenue: true, 
        },
        cta: "Update",
    },
    billingDetails: {
        title: "Update billing information",
        fields: {
            projectType: true,
            billableHours: true,
            nonBillableHours: true,
            billingRate: true,
            deadline: true,
        },
        cta: "Update",
    },
    trackingDetails: {
        title: "Project tracking settings",
        fields: {
            trackProject: true,
            trackingType: true,
            startTime: true,
            endTime: true,
        },
        cta: "Update",
    },
};

export const invoiceDetails = {
    "personal_account": {
        title: "Manual payment via bank account",
        accountNumber: true,
        bankName: true,
        accountName: true,
        sortCode: true,
        iban: true,
    },
    "payment_link": {
        title: "Via a payment link",
    },
    "automatic": {
        title: "Automatic settlement",
        accountNumber: true,
        bankName: true,
        accountName: true,
        sortCode: true,
        iban: true,
    },
};